import { V } from "../../../core/Vector";
import { BaseMunition, MunitionMovement } from "../BaseMunition";

const GRAVITY_FORCE_STRENGTH = 10;

export class GravityMovement implements MunitionMovement {
  update(munition: BaseMunition, dt: number): void {
    if (!munition.body) return;

    // Apply gravity toward center (like the turret is a planet)
    const gravityDirection = V(0, 0).sub(munition.body.position).normalize();
    const gravityForce = gravityDirection
      .imul(GRAVITY_FORCE_STRENGTH)
      .imul(munition.body.mass);
    munition.body.applyForce([gravityForce.x, gravityForce.y]);
  }
}
